<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__callback}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.name" placeholder="客户姓名" clearable></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-input v-model="dataForm.mobile" placeholder="手机号码" clearable></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.callStartDate"
                  type="date"
                  placeholder="回访开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.callEndDate"
                  type="date"
                  placeholder="回访结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.entryStartDate"
                  type="date"
                  placeholder="录入开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dataForm.entryEndDate"
                  type="date"
                  placeholder="录入结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.companyId" filterable  clearable placeholder="所属公司">
            <el-option
                    v-for="item in companys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-select v-model="dataForm.callType" filterable  clearable placeholder="回访结果">
            <el-option
                    v-for="item in callTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:callback:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:callback:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:callback:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column  type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:id')" prop="id" label="ID" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:userid')" prop="customerId" label="用户Id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:user')" prop="customerName" label="用户" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:mobile')" prop="mobile" label="手机号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:company')" prop="companyName" label="公司" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column v-if="$hasPermission('sys:callback:backtype')" prop="callType" label="回访类型" width="150px"  header-align="center" align="center">
        	<template slot-scope="scope">
            <el-tag  size="small" v-if="returnCall(scope.row.callType)">{{ returnCall(scope.row.callType)}}</el-tag>
        	</template>
        </el-table-column>
            <el-table-column  v-if="$hasPermission('sys:callback:push')" prop="content" label="推送内容" header-align="center" align="center" show-overflow-tooltip>
              <!-- <template slot-scope="scope">
                 <el-button  v-if="scope.row.content !=='string' && scope.row.content !==''" type="text" style="text-decoration: underline;" @click="handleReturnMsg(scope.row.content)">推送内容</el-button>
              </template> -->
            </el-table-column>
        <el-table-column   v-if="$hasPermission('sys:callback:remark')" prop="remark" label="备注" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column  v-if="$hasPermission('sys:callback:ispush')" prop="isPush" label="是否已推送" header-align="center" align="center" show-overflow-tooltip>
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.isPush === 1" size="small">是</el-tag>
	            <el-tag v-if="scope.row.isPush === 0" size="danger">否</el-tag>
        	</template>
        </el-table-column>
        <el-table-column  v-if="$hasPermission('sys:callback:backcode')" prop="pushCode" label="推送返回状态码" header-align="center" align="center">
          <template slot-scope="scope"> 
          
               <span v-if="scope.row.pushCode == 0" >成功</span>
	             <span v-else >失败</span>
          </template>
        </el-table-column>
        <el-table-column  v-if="$hasPermission('sys:callback:backcontent')" prop="pushMsg" label="推送返回信息" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushDate" label="推送时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="status" label="状态" header-align="center" align="center">
        	<template slot-scope="scope">
	            <el-tag v-if="scope.row.status === 0" size="danger">无效</el-tag>
	            <el-tag v-if="scope.row.status === 1" size="small">有效</el-tag>
        	</template>
        </el-table-column> -->
        <el-table-column  label="创建人" header-align="center" align="center" show-overflow-tooltip>
          <template>
            <div>
              {{$store.state.user.realName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateName" label="更新人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deleteTime" label="删除日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:callback:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:callback:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
    <el-dialog
      title="内容"
      :visible.sync="dialogVisible"
      width="30%"
     >
      <span>{{returnedMessagesVal}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './callback-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      dialogVisible: false,
      returnedMessagesVal:'',
      mixinViewModuleOptions: {
        getDataListURL: '/sys/callback/page',
        getDataListIsPage: true,
        exportURL: '/sys/callback/export',
        deleteURL: '/sys/callback',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      companys:[],
      callTypes:[],
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.query()
      this.getCompanysOptions();
      this.getCallTypeOptions()
    }
  },
  mounted(){
    console.log(this.$store)
  },
  methods: {
    handleReturnMsg(returnMsg){
      this.dialogVisible = true;
      this.$nextTick(() =>{
        this.returnedMessagesVal = returnMsg
      })
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
      this.$http.get(`/sys/companies/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.companys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.companys.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
    returnCall(element){
      if(element == null){
        return 
      }else{
        return this.callTypes.filter(item =>{
        return item.value == element
      } )[0]?.label 
      }
     
    },
    async getCallTypeOptions() {
          this.$http.get(`/sys/dict/data/list?dataType=return-type`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.callTypes = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                    this.callTypes.push({label: element.dictLabel ,value: element.dictValue})
                  })
              }
          }).catch(() => {})
      },
  }
}
</script>
